import { Component } from '@theme/component';

/**
 * Symptom checklist that counts what the visitor ticks.
 *
 * Deliberately holds nothing. No storage of any kind — the brief rules out
 * localStorage and sessionStorage, and a symptom list is health information a
 * shop has no business persisting in a browser anyway. Reload and it is empty.
 *
 * The result line is always in the DOM and always readable. Ticking boxes
 * promotes it rather than revealing it, so someone who scrolls straight past
 * still gets the payoff sentence — hiding it until four checks would trade the
 * message for the interaction.
 */
class RytmaChecklistComponent extends Component {
  // Deliberately no requiredRefs. A missing ref makes Component throw, and the
  // count is decoration — the checkboxes work without it. Nothing here should
  // be able to take the section down.
  connectedCallback() {
    super.connectedCallback();
    this.#update();
  }

  handleToggle() {
    this.#update();
  }

  #update() {
    try {
      this.#write();
    } catch (error) {
      // Never let a counter break the page. The checkboxes are native and keep
      // working whatever happens in here.
      console.warn('[rytma-checklist]', error);
    }
  }

  #write() {
    const boxes = this.querySelectorAll('.rytma-v3-cl__input');
    const checked = this.querySelectorAll('.rytma-v3-cl__input:checked').length;
    const threshold = Number(this.dataset.threshold) || 4;

    const count = this.refs.count;
    if (count instanceof HTMLElement) {
      count.textContent = `${checked} of ${boxes.length} selected`;
      // Silent until they engage: "0 of 6" on load is noise, not information.
      count.hidden = checked === 0;
    }

    this.toggleAttribute('data-met', checked >= threshold);
  }
}

if (!customElements.get('rytma-checklist-component')) {
  customElements.define('rytma-checklist-component', RytmaChecklistComponent);
}
